import Seo from '@/components/seo/Seo';
import DetailSkeletonProdukContent from '@/components/skeleton/DetailSkeletonProdukContent';
import { BodySmHTML, H4 } from '@/components/ui/typography/Typography';
import { ApiService } from '@/services/api.services';
import { useEffect, useState } from 'react';
import { Navigate, useOutletContext, useParams } from 'react-router-dom';

export default function ProductServiceItemDetail() {
  const { slug, item } = useParams();
  const parentDetail = useOutletContext(); // ambil detail parent dari Outlet

  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!item) {
      setDetail(parentDetail);
      setLoading(false);
      return;
    }

    const fetchItem = async () => {
      try {
        setLoading(true);
        const res = await ApiService.getServiceItem(slug, item);
        setDetail(res.data);
      } catch {
        setDetail(null);
      } finally {
        setLoading(false);
      }
    };

    fetchItem();
  }, [slug, item, parentDetail]);

  if (loading) return <DetailSkeletonProdukContent />;
  if (!detail) return <Navigate to="/404" replace />;

  const title = `${detail.title} | ${parentDetail?.title || 'Produk Layanan'} | Abdi Kerta Raharja`;

  const description =
    detail.meta_description ||
    (detail.content || detail.description || '').replace(/<[^>]+>/g, '').slice(0, 155);

  const canonical = `https://www.abdikertaraharja.co.id/produk-layanan/${slug}/${item}`;

  return (
    <>
      <Seo title={title} description={description} canonical={canonical} />
      <H4>{detail.title}</H4>
      <BodySmHTML content={detail.content || detail.description} className={'py-2'} />
    </>
  );
}
